import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusService {


  private Employee = {};
  private Loc = [];


  Emp$ = new BehaviorSubject<any>(this.Employee);
  Loc$ = new BehaviorSubject<any>(this.Loc);


  constructor() { }

  setEmployee(Employee:any){

    this.Emp$.next(Employee);
  }

  setLoc(Loc:any){

    this.Loc$.next(Loc);
  }

}
